import {ref} from 'vue'
import {defineStore} from 'pinia'
import type {PostCategoryModel} from "@/shared/models/post_category_model.ts";

export interface IPostCategoriesStore {
    get(params?: { limit: number }): PostCategoryModel[]

    set(value: PostCategoryModel | PostCategoryModel[]): void

    getById(id: number): PostCategoryModel | null

    getBySlug(slug: string): PostCategoryModel | null

    deleteById(id: number): void

    deleteAll(): void
}

export const usePostCategoriesStore = defineStore('posts_categories', (): IPostCategoriesStore => {
    const data = ref<PostCategoryModel[]>([])

    const get = (params?: { limit?: number }): PostCategoryModel[] => {
        if (params && params.limit) {
            return data.value.slice(0, params.limit) as PostCategoryModel[]
        }
        return data.value as PostCategoryModel[]
    }

    const set = (value: PostCategoryModel | PostCategoryModel[]): void => {
        if (Array.isArray(value)) {
            value.forEach((item) => {
                const index = data.value.findIndex(value => value.id === item.id)
                if (index < 0) {
                    data.value.push(item)
                } else {
                    data.value[index] = item
                }
            })
        } else {
            const item = value
            const index = data.value.findIndex(value => value.id === item.id)
            if (index < 0) {
                data.value.push(value)
            } else {
                data.value[index] = value
            }
        }
        data.value = data.value.sort((a, b) => b.id - a.id)
    }

    const getById = (id: number): PostCategoryModel | null => {
        const index = data.value.findIndex(value => value.id === id)
        if (index >= 0) {
            return data.value[index] as PostCategoryModel
        }
        return null
    }

    const getBySlug = (slug: string): PostCategoryModel | null => {
        const index = data.value.findIndex(value => value.slug === slug)
        if (index >= 0) {
            return data.value[index] as PostCategoryModel
        }
        return null
    }

    const deleteById = (id: number): void => {
        const index = data.value.findIndex(value => value.id === id)
        if (index >= 0) {
            data.value.splice(index, 1)
        }
    }

    const deleteAll = (): void => {
        data.value = []
    }

    return {set, get, getById, getBySlug, deleteById, deleteAll}
})